module.exports = __webpack_public_path__ + "static/media/Dr-Hector-Morbelli.2431149e.jpg";